import { apiSlice } from "../../app/api/apiSlice";

// API about Feedback Session
export const FeedbackSessionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get every feedback session
    getFeedbackSessions: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/feedbacks/",
        method: "GET",
        params,
      }),
      providesTags: ["Feedback"]
    }),

    // Get one feedback session from id
    fetchFeedbackSessionById: builder.query({
      query: (id) => ({
        url: `/api/v1/resources/feedbacks/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Feedback", id }],
    }),

    // Create new feedback session
    createFeedbackSession: builder.mutation({
      query: (args) => ({
        url: "/api/v1/resources/feedbacks/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: ["Feedback"],
    }),

    // Delete one feedback session by id
    deleteFeedbackSession: builder.mutation({
      query: (id) => ({
        url: `/api/v1/resources/feedbacks/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Feedback"],
    })
  })
});

// API about feedback log
export const FeedbackLogApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get every feedback log
    getFeedbackLogs: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/feedbacks_logs/",
        method: "GET",
        params,
      }),
      providesTags: ["Feedback"]
    }),

    // Update one feedback log from id
    updateFeedbackLogById: builder.mutation({
      query: (args) => ({
        url: `/api/v1/resources/feedbacks_logs/${args.id}/`,
        method: "PUT",
        body: args
      }),
      providesTags: (result, error, id) => [{ type: "Feedback", id }],
    }),

    // Create new feedback log
    createFeedbackLog: builder.mutation({
      query: (args) => ({
        url: "/api/v1/resources/feedbacks_logs/",
        method: "POST",
        body: args,
      }),
      invalidatesTags: ["Feedback"],
    }),

    // Delete one feedback log by id
    deleteFeedbackLog: builder.mutation({
      query: (id) => ({
        url: `/api/v1/resources/feedbacks_logs/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["Feedback"],
    }),
  }),
});

// Export endpoint functions
export const {
  useGetFeedbackSessionsQuery,
  useFetchFeedbackSessionByIdQuery,
  useCreateFeedbackSessionMutation,
  useDeleteFeedbackSessionMutation,
} = FeedbackSessionApiSlice;

export const {
  useGetFeedbackLogsQuery,
  useUpdateFeedbackLogByIdMutation,
  useCreateFeedbackLogMutation,
  useDeleteFeedbackLogMutation,
} = FeedbackLogApiSlice;